export const EMAIL_PIN_LENGTH = 6;

/** Must match services `PIN_EXPIRATION_MINUTES` in EmailPinSendService. */
export const EMAIL_PIN_EXPIRATION_MINUTES = 15;

export interface EmailPinSendParams {
  email: string;
}

export type EmailPinSendError = 'invalid_email';

export interface EmailPinSendResult {
  success: boolean;
  error?: EmailPinSendError;
}

export interface EmailPinCodeAccessParams {
  email: string;
  code: string;
}

export type EmailPinCodeAccessError = 'invalid_code';

export interface EmailPinCodeAccessResult {
  success: boolean;
  token?: string;
  error?: EmailPinCodeAccessError;
}

export interface EmailPinSignInResult {
  success: boolean;
  uid?: string;
  error?: EmailPinCodeAccessError;
}
